import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "accueil",
    component: () => import("../views/accueil"),
    meta:{
      title:'ACCUEIL',
	    en_title:'HOME'
    }
  },
  {
    path: "/croire",
    name: "croire",
    component: () => import("../views/croire"),
    meta:{
      title:'CROIRE',
	    en_title:'BELIEVE'
    },
  },
  {
    path: "/vivre",
    name: "vivre",
    component: () => import("../views/vivre"),
    meta:{
      title:'VIVRE',
	    en_title:'VIVRE'
    },
  },
  {
    path: "/calendrier",
    name: "calendrier",
    component: () => import("../views/calendrier"),
    meta:{
      title:'CALENDRIER',
	    en_title:'CALENDAR'
    },
  },
  {
    path: "/rencontrer/:type",
    name: "rencontrer",
    component: () => import("../views/rencontrer"),
    meta:{
      title:'RENCONTRER',
	    en_title:'CONTACT'
    }
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
	let language = localStorage.getItem('language')?localStorage.getItem('language'):'fr'
  if (to.meta && to.meta.title) {
    document.title = language=='en'?to.meta.en_title:to.meta.title
  }
  next()
})

router.afterEach((to, from) => {
  if(from.name == to.name){
    location.reload()
  }
})

export default router;
